export default {
  statusPanel: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    justifyContent: 'left',
    paddingLeft: '0px',
    paddingRight: '0px',
    paddingTop: '0px',
    paddingBottom: '0px',
  },
};
